module.exports = __webpack_public_path__ + "img/receipt7.d2c97114.png";